export default "/images/6593c3ed3d22380a2b4f28c216205e8a.avif";